var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3938_45514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM13 9C10.791 9.00012 9.00012 10.791 9 13V19C9.00012 21.2089 10.791 22.9999 13 23H19C21.2089 22.9999 22.9999 21.2089 23 19V13C22.9999 10.791 21.2089 9.00012 19 9H13ZM16 12.3057C18.0404 12.3057 19.6943 13.9596 19.6943 16C19.6943 16.9798 19.3051 17.9195 18.6123 18.6123C17.9195 19.3051 16.9798 19.6943 16 19.6943C13.9596 19.6943 12.3057 18.0404 12.3057 16C12.3057 13.9596 13.9596 12.3057 16 12.3057ZM16 13.4727C14.6039 13.4727 13.4727 14.6039 13.4727 16C13.4727 17.3961 14.6039 18.5273 16 18.5273C16.6703 18.5273 17.3131 18.2612 17.7871 17.7871C18.2612 17.3131 18.5273 16.6703 18.5273 16C18.5273 14.6039 17.3961 13.4727 16 13.4727ZM19.8887 11.333C20.3182 11.333 20.667 11.6818 20.667 12.1113C20.6669 12.5408 20.3182 12.8887 19.8887 12.8887C19.4593 12.8886 19.1114 12.5407 19.1113 12.1113C19.1113 11.6818 19.4592 11.3331 19.8887 11.333Z",
    fill: "#0B193E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3938_45514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9cebbe5b1506ce826a638c48397e3a82.svg";
export { ForwardRef as ReactComponent };